import { useParams } from 'react-router-dom';
import useApiFetch from '@/hooks/useApiFetch';
import { FetchApiIds } from '@/types';
import seoContentService from '@/services/seoContent';
import { SeoContentAnalysis } from '@/types/api/seo';
import SeoContentDetailComponent from './SeoContentDetail.component';

const SeoContentDetailPage = function (): JSX.Element {
  const { analysisId } = useParams();

  const analysisResponse = useApiFetch<SeoContentAnalysis, void>(
    [FetchApiIds.SEO_CONTENT_ANALYSIS_BY_ID, analysisId],
    async () => seoContentService.getById(analysisId as string)
  );

  return (
    <SeoContentDetailComponent
      analysis={analysisResponse.data as SeoContentAnalysis | null}
      isLoading={analysisResponse.isLoading}
      notFound={analysisResponse.isError}
    />
  );
};

export default SeoContentDetailPage;
